import { render, staticRenderFns } from "./TicketBoardCardTemplate.vue?vue&type=template&id=06c28f8c&scoped=true"
import script from "./TicketBoardCardTemplate.vue?vue&type=script&lang=js"
export * from "./TicketBoardCardTemplate.vue?vue&type=script&lang=js"
import style0 from "./TicketBoardCardTemplate.vue?vue&type=style&index=0&id=06c28f8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c28f8c",
  null
  
)

export default component.exports